// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const klang: PokeData = {
  "id": 600,
  "name": "klang",
  "height": 6,
  "weight": 510,
  "base_experience": 154,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "vice-grip",
    "bind",
    "hyper-beam",
    "thunder-shock",
    "screech",
    "zap-cannon",
    "lock-on",
    "charge",
    "metal-sound",
    "mirror-shot",
    "discharge",
    "charge-beam",
    "autotomize",
    "shift-gear",
    "gear-grind"
  ],
  "moves": [
    "thunder-shock",
    "zap-cannon",
    "metal-sound",
    "scrap-throw",
    "magnet-pull",
    "smart-strike",
    "gear-up",
    "metal-burst",
    "magnet-bomb",
    "iron-defense",
    "metal-claw",
    "metal-rush"
  ],
  "evolution_chain": {
    "id": 305,
    "item": null,
    "species": [
      {
        "name": "klink",
        "order": 600,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "klang",
        "order": 601,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 599,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "klinklang",
        "order": 602,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 600,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 49,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 50,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
